import Quill from 'quill'

const Module = Quill.import('core/module')
const Tooltip = Quill.import('ui/tooltip')

class SidebarTooltip extends Tooltip {}
SidebarTooltip.TEMPLATE = `<span class="ql-arrow-right"></span>
	<div class="ql-formats">
		<ul>
			<li>
			<button class="sidebar-button ql-image">
			<svg width="18" height="15" viewBox="0 0 21 17">
			  <g fill="#fff">
					<path fill-rule="nonzero" d="M1,16 L20,16 L20,1 L1,1 L1,16 Z M0,0 L21,0 L21,17 L0,17 L0,0 Z"/>
					<path d="M8,17 L0,17 L5.54902482,5.90195036 C5.79809153,5.40381693 6.19963074,5.39926147 6.45097518,5.90195036 L9.81146778,12.6229356 L12.3575156,10.7053107 C12.7973168,10.3740625 13.4909856,10.4017794 13.9061684,10.7666032 L21,17 L8,17 Z M14,6 C14,4.8954305 14.8877296,4 16,4 C17.1045695,4 18,4.88772964 18,6 C18,7.1045695 17.1122704,8 16,8 C14.8954305,8 14,7.11227036 14,6 Z"/>
				</g>
			</svg>
			</button>
			</li>
			<li>
			<button class="sidebar-button ql-video">
			<svg width="18" height="15" viewBox="0 0 15 16">
				<g fill="#fff">
					<path d="M148.347189,5.56723184 C148.604173,5.07382212 149.021466,5.07504827 149.277811,5.56723184 L156.159689,18.7804372 C156.416673,19.2738469 156.174225,19.6738345 155.623817,19.6738345 L142.001183,19.6738345 C141.448245,19.6738345 141.208966,19.2726207 141.465311,18.7804372 L148.347189,5.56723184 Z" transform="rotate(90 80.5 -60.5)"/>
				</g>
			</svg>
			</button>
			</li>
			<li>
			<button class="sidebar-button ql-bullet-list">
			<svg width="18" height="15" viewBox="0 0 15 16">
				<g fill="#fff">
					<path d="M 4.132812 2.730469 C 4.132812 3.683594 3.207031 4.453125 2.066406 4.453125 C 0.925781 4.453125 0 3.683594 0 2.730469 C 0 1.78125 0.925781 1.007812 2.066406 1.007812 C 3.207031 1.007812 4.132812 1.78125 4.132812 2.730469 Z M 4.132812 2.730469 "/>
					<path d="M 4.132812 7.46875 C 4.132812 8.417969 3.207031 9.191406 2.066406 9.191406 C 0.925781 9.191406 0 8.417969 0 7.46875 C 0 6.515625 0.925781 5.746094 2.066406 5.746094 C 3.207031 5.746094 4.132812 6.515625 4.132812 7.46875 Z M 4.132812 7.46875 "/>
					<path d="M 4.132812 12.347656 C 4.132812 13.296875 3.207031 14.070312 2.066406 14.070312 C 0.925781 14.070312 0 13.296875 0 12.347656 C 0 11.394531 0.925781 10.625 2.066406 10.625 C 3.207031 10.625 4.132812 11.394531 4.132812 12.347656 Z M 4.132812 12.347656 "/>
					<path d="M 6.492188 3.855469 L 17.714844 3.855469 C 17.816406 3.855469 17.910156 3.824219 17.984375 3.765625 C 18.054688 3.707031 18.09375 3.625 18.09375 3.542969 L 18.09375 1.917969 C 18.09375 1.746094 17.921875 1.605469 17.714844 1.605469 L 6.492188 1.605469 C 6.28125 1.605469 6.113281 1.746094 6.113281 1.917969 L 6.113281 3.542969 C 6.113281 3.714844 6.28125 3.855469 6.492188 3.855469 Z M 6.492188 3.855469 "/>
					<path d="M 17.714844 6.339844 L 6.492188 6.339844 C 6.28125 6.339844 6.113281 6.480469 6.113281 6.65625 L 6.113281 8.277344 C 6.113281 8.453125 6.28125 8.59375 6.492188 8.59375 L 17.714844 8.59375 C 17.816406 8.59375 17.910156 8.5625 17.984375 8.5 C 18.054688 8.441406 18.09375 8.363281 18.09375 8.277344 L 18.09375 6.65625 C 18.09375 6.480469 17.925781 6.339844 17.714844 6.339844 Z M 17.714844 6.339844 "/>
					<path d="M 17.714844 11.21875 L 6.492188 11.21875 C 6.28125 11.21875 6.113281 11.363281 6.113281 11.535156 L 6.113281 13.15625 C 6.113281 13.332031 6.28125 13.472656 6.492188 13.472656 L 17.714844 13.472656 C 17.816406 13.472656 17.910156 13.441406 17.984375 13.382812 C 18.054688 13.320312 18.09375 13.242188 18.09375 13.15625 L 18.09375 11.535156 C 18.09375 11.363281 17.925781 11.21875 17.714844 11.21875 Z M 17.714844 11.21875 "/>
				</g>
			</svg>
			</button>
			</li>
		</ul>
		<input class="ql-file" type="file" accept=".gif,.jpg,.jpeg,.png">
	</div>
`

class Sidebar extends Module {
	constructor (quill, options) {
		super(quill, options)

		this.sidebar = new SidebarTooltip(quill, options.bounds)
		quill.on('editor-change', this.editorChange.bind(this))

		this.elem = this.sidebar.root
		this.elem.classList.add('ql-sidebar')

		this.initializeHandlers()
	}

	initializeHandlers () {
		let imageInput = this.elem.querySelector('.ql-file')
		let videoButton = this.elem.querySelector('.ql-video')
		let imageButton = this.elem.querySelector('.ql-image')
		let bulletListButton = this.elem.querySelector('.ql-bullet-list')

		imageButton.addEventListener('click', () => {
			imageInput.click()
		})

		videoButton.addEventListener('click', () => {
			this.options.handlers['video'].call(this)
		})

		bulletListButton.addEventListener('click', () => {
			this.options.handlers['bullet-list'].call(this)
		})

		imageInput.addEventListener('change', () => {
			if (imageInput.files && imageInput.files[0]) {
				this.options.handlers['image'].call(this, imageInput.files[0])
				imageInput.value = ''
			}
		})
	}

	editorChange (type, range) {
		if (type !== 'selection-change') return
		if (range == null) return this.sidebar.hide()
		let [line, offset] = this.quill.getLine(range.index)

		if (offset === 0 && range.length === 0 && line.length() === 1) {
			this.reposition(range)
			this.sidebar.show()
		} else {
			this.sidebar.hide()
		}
	}

	reposition (range) {
		let elem = this.sidebar.root
		let bounds = this.quill.getBounds(range)

		elem.style.top = `${bounds.top - 32}px`
		elem.style.left = '-55px'
	}
}

export { Sidebar as default }
